import { Observable } from 'rxjs';
import { BaseWebComponentElement } from '../../../../../framework/BaseWebComponentElement';
import { CustomRuleFormData } from '../../imAddCustomRulePanel/types';
import { IntegrityMonitorCustomRuleMainFormController } from '../controller/IntegrityMonitorCustomRuleMainFormController';

export class IntegrityMonitorCustomRuleMainFormWebComponent extends BaseWebComponentElement {
  public controller!: IntegrityMonitorCustomRuleMainFormController;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: IntegrityMonitorCustomRuleMainFormController,
    });
  }

  public get value() {
    return this.controller.getValue();
  }

  public get valid$(): Observable<boolean> {
    return this.controller.createObservable();
  }

  public get valid(): boolean {
    return this.controller.isValid();
  }

  public reset(): void {
    this.controller.resetForm();
    this.controller.view.dom.$ruleEntityTypeFormField.disabled = false;
    this.controller.view.editRuleId = null;
  }

  public setData(ruleData: CustomRuleFormData) {
    this.controller.setData(ruleData);
    this.controller.view.dom.$ruleEntityTypeFormField.disabled = true;
    this.controller.view.editRuleId = ruleData._id ? ruleData._id : null;
  }
}
